import { Component, Input, OnInit } from '@angular/core';
import { VerticalExpansionSlower_withDelay } from 'src/app/animations/VerticalExpansion';
import { ProductQuestion } from 'src/app/models/ProductQuestion';

@Component({
	selector: 'app-question-and-answer',
	templateUrl: './question-and-answer.component.html',
	styleUrls: ['./question-and-answer.component.scss'],
	animations: [VerticalExpansionSlower_withDelay]
})
export class QuestionAndAnswerComponent implements OnInit {

	@Input() productQuestion! : ProductQuestion;
	@Input() disableAnimation = false;
	ariaLabel! : string;

	ngOnInit(): void {
		this.ariaLabel = "Pregunta: "+ this.productQuestion.caption;
		if (this.productQuestion.answer)
			this.ariaLabel += ". Respuesta: "+ this.productQuestion.answer
		else
			this.ariaLabel += ". Esta pregunta no tiene respuesta aún."
	}
}